import { IProductStatusIn } from "../../models/input/generalApi/IProductStatusIn";
import * as ApiWithToken from "../callApiWithToken";

const productService = {
  postImage: async function (
    imageFile: FormData,
    folder: string,
    date: string
  ) {
    return ApiWithToken.postImageApi(
      process.env.REACT_APP_GENERAL_API +
      `Products/UploadImage?Folder=${folder}/${date}`,
      imageFile
    );
  },
  getProductsBySubretail: async function (pageNumber: number, pageSize: number, subretailID: number, languageID: number, sku: string, marketingName: string, categoryFilter: number | null) {
    let url = process.env.REACT_APP_GENERAL_API + `Products/GetProductBySubretailWeb?pageNumber=${pageNumber}&pageSize=${pageSize}&subretailID=${subretailID}&languageID=${languageID}&sku=${sku}&marketingName=${marketingName}`;
    if (categoryFilter !== null) {
      url += `&categoryID=${categoryFilter}`;
    }
    return ApiWithToken.getApi(url);
  },
  updateProductStatus: async function (productStatusIn: IProductStatusIn) {
    return ApiWithToken.putApi(
      process.env.REACT_APP_GENERAL_API + `Products/UpdateProductsByFilters`,
      productStatusIn
    );
  },
  getCategoriesList: async function (languageId: number, level: string) {
      return ApiWithToken.getApi(process.env.REACT_APP_GENERAL_API + `Products/GetCategoriesByLevel?languageID=${languageId}&level=${level}`);
  },

};

export default productService;
